import SoftTypography from "components/SoftTypography";
import roundNum from "utils/roundNum";

export default function Cost({ cost, pair }) {
    return (
        <SoftTypography className="table-number">
            {`${roundNum(cost)} ${pair.split("-")[1]}`}
        </SoftTypography>
    )
}